
import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import { Button, Form, Container, Row, Col, Card, Spinner, Toast, Alert } from 'react-bootstrap';
import { FcBusinessman, FcBusinesswoman } from "react-icons/fc";
import { useLocation, useNavigate } from "react-router-dom"
export default function Consulting() {
    // alert()
    const navigate = useNavigate();
    const location = useLocation()
    const propsData = location.state.patientInformation;
    console.log("props", location.state.patientInformation)
    const [apiCalling, setApiCalling] = useState(false)
    const [show, setShow] = useState(false);
    const [recording, setrecording] = useState(false)
    const [patientInformation, setPatientInformation] = useState(
        //     {
        //     name: props.patientInformation.name,
        //     age: props.patientInformation.age,
        //     gender: props.patientInformation.gender,
        //     bloodGroup: props.patientInformation.bloodGroup,
        //     sugarLavel: props.patientInformation.sugarLavel,
        //     bplevel: props.patientInformation.bplevel
        // }
        propsData
    )
    const [recordedUrl, setRecordedUrl] = useState(null);
    const mediaStream = useRef(null);
    const mediaRecorder = useRef(null);
    const chunks = useRef([]);
    const [formData, setFormData] = useState({"patiendId" : propsData.id})
    const [isSubmitBtn, setIsSubmitBtn] = useState(false)

    const updateInformation = (e) => {
        e.preventDefault();
        setApiCalling(true)
        axios.put(`https://684e67d4f0c9c9848d280f2a.mockapi.io/patientlist/${propsData.id}`, patientInformation)
            .then(res => {
                console.log("res", res)
                 setApiCalling(false)
                    setShow(true)
            })
            .catch(err => {
                console.log("Err", err)
                setApiCalling(false)
            })
    }
    const updateData = (e) => {
        const { name, value } = e.currentTarget;
        console.log("name", name, value)
        setPatientInformation({ ...patientInformation, [name]: value })
    }
    const bloodGroupoList = [
        { value: 'A+', label: 'A+' },
        { value: 'A-', label: 'A-' },
        { value: 'B+', label: 'B+' },
        { value: 'B-', label: 'B-' },
        { value: 'AB+', label: 'AB+' },
        { value: 'AB-', label: 'AB-' },
        { value: 'O+', label: 'O+' },
        { value: 'O-', label: 'O-' },
    ];
    const toggleRecording = () => {

        if (!recording) {
            setIsSubmitBtn(false)
            let stream = navigator.mediaDevices.getUserMedia({
                audio: {
                    autoGainControl: false,
                    echoCancellation: true,
                    noiseSuppression: true
                },
                video: false
            })
            //returns a promise that resolves to the audio stream
            stream.then(stream => {
                mediaStream.current = stream;
                mediaRecorder.current = new MediaRecorder(stream);
                mediaRecorder.current.start();
                setrecording(true)
            })

        }
        else {
            setrecording(false)
            mediaRecorder.current.stop();
            mediaRecorder.current.ondataavailable = event => {
                console.log("erererer", event.data)
                if (event.data.size > 0) {
                    chunks.current.push(event.data);
                    setIsSubmitBtn(true)
                }
                const recordedBlob = new Blob(
                    chunks.current, { type: 'audio/mp3' }
                );
                setFormData({...formData,"audio": recordedBlob})
                console.log("recordedBlob", recordedBlob)
                const url = URL.createObjectURL(recordedBlob);
                setRecordedUrl(url);
                console.log("recordedBloburl", url)
                chunks.current = [];
            }
        }
    }
    const submitAudioData = ()=>{
        console.log("formData", formData)
    }

    useEffect(() => {

    }, [])
    return (
        <div className="consultingWraper py-3">
            <Container>
                <button type='button' className="btn btn-link mb-4" onClick={() => navigate(-1)}>Back to info Page</button>
                <Row>
                    <Col sm={8}>
                        <div className="audio-sec">
                            <audio controls src={recordedUrl} />
                        </div>

                        <div className="text-end pt-4">

                            <Button
                                type="button"
                                variant="primary"
                                onClick={toggleRecording}
                                className="login-btn text-white w-auto">
                                {
                                    recording ? "Stop Recording" : "Start Recording"
                                }

                            </Button>

                                <Button
                                onClick={submitAudioData}
                                    type="button"
                                    variant="primary"
                                    disabled={!isSubmitBtn?'disabled':''}
                                    className="login-btn text-white w-auto ms-4">
                                    Submit Data
                                </Button>

                        </div>

                    </Col>
                    <Col sm={4}>
                        <Card>

                            <Card.Body>
                                <Card.Title className="mb-3">Patient Information</Card.Title>
                                <form onSubmit={updateInformation}>

                                    <div className="mb-3">
                                        <Form.Label htmlFor="" className="fw-bold">Full Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id=""
                                            name="name"
                                            onChange={updateData}
                                            value={patientInformation.name}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label className="fw-bold">Choose User Type</Form.Label>
                                        <div>
                                            <label className="custom-radio-btn">
                                                <input type='radio' name='gender' value="male" checked={patientInformation.gender.toLowerCase() === 'male'} onChange={updateData} />
                                                <span className="checkMark"><FcBusinessman style={{ width: "30px", height: "30px" }} />Male</span>
                                            </label>
                                            <label className="custom-radio-btn ms-3">
                                                <input type='radio' name='gender' value="female" checked={patientInformation.gender.toLowerCase() === 'female'} onChange={updateData} />
                                                <span className="checkMark"><FcBusinesswoman style={{ width: "30px", height: "30px" }} />Female</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label htmlFor="" className="fw-bold">Age</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id=""
                                            name="age"
                                            value={patientInformation.age}
                                            onChange={updateData}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label htmlFor="" className="fw-bold">Disease</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id=""
                                            name="diseas"
                                            value={patientInformation.diseas}
                                            onChange={updateData}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label htmlFor="" className="fw-bold">Department</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id=""
                                            name="depertment"
                                            value={patientInformation.depertment}
                                            onChange={updateData}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label htmlFor="" className="fw-bold">Sugar Label</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id=""
                                            name="sugarLavel"
                                            value={patientInformation.sugarLavel}
                                            onChange={updateData}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label htmlFor="" className="fw-bold">Blood group</Form.Label>
                                        <Form.Select value={patientInformation.bloodGroup} name="bloodGroup" onChange={updateData}>
                                            {bloodGroupoList.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}

                                        </Form.Select>
                                    </div>
                                    <div className="mb-3">
                                        <Form.Label htmlFor="" className="fw-bold">BP Label</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id=""
                                            name="bplevel"
                                            value={patientInformation.bplevel}
                                            onChange={updateData}
                                        />
                                    </div>
                                    <p className="text-end">
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            disabled={apiCalling}
                                            className="login-btn text-white w-auto">
                                            Update Patient Information
                                            {apiCalling &&
                                                <Spinner animation="border" variant="light" size="sm" className="ms-2" />
                                            }

                                        </Button>
                                    </p>
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Toast onClose={() => setShow(false)} show={show} className="success-toast" autohide>
                <Alert variant={"primary"} className="mb-0">
                    Patient Information updated Successfully
                </Alert>
            </Toast>
        </div>
    )

}